module.exports = __webpack_public_path__ + "templates-59e97cd7/template-6-preview-4ffb1c5bb2567b7d7022d04206e7d66d.jpg";